import { ApexOptions } from 'apexcharts';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import CardHeader from '@mui/material/CardHeader';
import Card, { CardProps } from '@mui/material/Card';
// utils
import { fNumber } from 'src/utils/format-number';
// components
import Chart, { useChart } from 'src/components/chart';
import { useEffect } from 'react';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 100;

const LEGEND_HEIGHT = 72;

const StyledChart = styled(Chart)(({ theme }) => ({
  height: CHART_HEIGHT,
  '& .apexcharts-canvas, .apexcharts-inner, svg, foreignObject': {
    height: `100% !important`,
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    borderTop: `dashed 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
    display:'none'
  },
}));

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title?: string;
  subheader?: string;
  total: number;
  fontSize?: string;
  chart: {
    colors?: string[];
    series: {
      label: string;
      value: number;
    }[];
    options?: ApexOptions;
  };
}

export default function AppCurrentDownload({ title, subheader, chart, total,fontSize='16px', ...other }: Props) {
  const theme = useTheme();

  const { colors, series, options } = chart;

  const chartSeries = series.map((i) => i.value);

  const chartOptions = useChart({
    chart: {
      sparkline: {
        enabled: true,
      },
    },
    colors,
    labels: series.map((i) => i.label),
    stroke: { colors: [theme.palette.background.paper] },
    // legend: {
    //   offsetY: 0,
    //   floating: true,
    //   position: 'top',
    //   horizontalAlign: 'center',
    // },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (value: number) => `${fNumber(value)} g`, // Add 'g' to the end
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          labels: {

            value: {
              formatter: (value: number | string) => `${fNumber(value)} g`,
              fontSize,
            },
            total: {
              // label: `${fNumber(chart.series[0].value)} P | ${fNumber(chart.series[1].value)} KH | ${fNumber(chart.series[2].value)} F`,
              label: `kcal`,
              fontSize: '5px!important',
              formatter: () => {
                const sum = total;
                return `${fNumber(total)}`;
              },
            },
          },
        },
      },
    },
    ...options,
  });
  useEffect(() => {
    chartOptions.labels = series.map((i) => i.label);
    chartOptions.series = chartSeries;
  }, [total, chartOptions, chartSeries, series]);
  return (
      <div>


      <StyledChart
        dir="ltr"
        type="donut"
        series={chartSeries}
        options={chartOptions}
        height={180}
      />
      </div>
  );
}
